import {
  Autocomplete,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import PreviewIcon from "@mui/icons-material/Preview";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import axiosInstance from "../../../axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import PersonIcon from "@mui/icons-material/Person";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import SendEmailModal from "../../Modal/Quotes/QuoteDetails/SendEmailModal";
import { openModal } from "../../../redux/actions/actions";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import CreateNewStudentModal from "../../Modal/Quotes/QuoteDetails/CreateNewStudentModal";
import DiscountRequestModal from "./DiscountRequestModal";
import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";


import paperBackFirstImg from "../../../assets/images/masks/paper-back-1.svg";
import paperBackSecondImg from "../../../assets/images/masks/paper-back-2.svg";
import { useTranslation } from "react-i18next";

export default function QuoteDetilsComp({
  quoteDetails,
  setQuoteDetails,
  getQuoteDetails,
  students,
  setStudents,
  getStudents,
}) {
  const { t, i18n } = useTranslation();

  const [formValues, setFormValues] = useState();
  const [coursesControl, setCoursesControl] = useState(false);
  const [loader, setLoader] = useState(false);
  const [newStudentControl, setNewStudentControl] = useState(false);
  const [warningMessage, setWarningMessage] = useState(null);

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  const theme = useTheme();

  const dispatch = useDispatch();
  const handleOpenModal = (data) => {
    // Dispatch an action to open the modal, with the FilterModal component as the payload
    dispatch(
      openModal(
        <DiscountRequestModal
          data={data}
          getQuoteDetails={getQuoteDetails}
          getStudents={getStudents}
        />,
        "discount_request"
      )
    );
  };

  const lightMode = useSelector((state) => state.mode.lightMode);
  const selectedBranchesString = useSelector(
    (state) => state?.branches?.branchesString
  );
  const navigate = useNavigate();

  const handleChange = (eventOrValue, name) => {
    if (dayjs.isDayjs(eventOrValue)) {
      // Eğer eventOrValue bir dayjs nesnesi ise (DatePicker'dan gelme durumu)
      setFormValues((prev) => ({
        ...prev,
        [name]: dayjs(eventOrValue).format("YYYY-MM-DD"), // newValue direkt olarak kullanılıyor ve formatlanıyor
      }));
    } else {
      const { name, value } = eventOrValue.target;
      // Diğer inputlar için standart işleme
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const [selectedStudent, setSelectedStudent] = useState();

  const handleChangeStudent = (_event, newValue) => {
    console.log(newValue, 'new value here');

    setSelectedStudent(newValue);
    handleUpdateQuote(newValue);
  };

  const paraFormat = (number) => {
    const formatter = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    });
    return formatter.format(number);
  };

  const handleChangeCourseControl = () => {
    setCoursesControl(!coursesControl);
  };

  useEffect(() => {
    console.log("form values here", formValues);

    if (formValues) {
      if (!formValues?.expiry_date) {
        setFormValues((prev) => ({
          ...prev,
          expiry_date:
            quoteDetails?.quote?.expiry_date || dayjs().format("YYYY-MM-DD"), // newValue direkt olarak kullanılıyor ve formatlanıyor
        }));
      }
    }
  }, [formValues]);

  useEffect(() => {
    if (selectedStudent) {
      setFormValues((prev) => ({
        ...prev,
        student: selectedStudent,
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        student: null,
      }));
    }
  }, [selectedStudent]);
  useEffect(() => {
    //!formValues?.options
    // let options = [];
    // quoteDetails?.options?.forEach((option, idx) => {
    //   // Yeni bir option objesi oluşturuluyor.
    //   let optionObj = {
    //     name: `Option ${idx + 1}`,
    //     accommodations: [
    //       {
    //         courses: [],
    //         services: [],
    //       },
    //     ],
    //   };

    //   // Bu sefer, her option için tüm courses üzerinde dönülüyor.
    //   option?.courses?.forEach((course, courseIndex) => {
    //     optionObj.accommodations[0].courses.push({
    //       course_id: course?.option_course_id,
    //       campus_id: course?.course?.campus?.campus_id,
    //       option_course_name: course?.option_course_name,
    //       option_course_partner: course?.option_course_partner,
    //       option_course_campus: course?.option_course_campus,
    //       option_course_start_date: dayjs(formValues?.checkIn)?.format(
    //         "YYYY-MM-DD"
    //       ),
    //       option_course_end_date: dayjs(formValues?.checkOut)?.format(
    //         "YYYY-MM-DD"
    //       ),
    //       option_course_course_type: course?.type_name,
    //       promotions: course?.promotion,
    //     });
    //   });

    //   option?.services?.forEach((service, serviceIndex) => {
    //     optionObj.accommodations[0].services.push({
    //       new_service_id: service?.new_service?.service_id,
    //       option_service_name: service?.new_service?.service_name,
    //       option_service_quantity: service?.option_service_quantity || null,
    //     });
    //   });

    //   option?.promotions?.forEach((promotion, promotionIndex) => {
    //     optionObj.accommodations[0].promotions.push({
    //       promotion_id: promotion?.option?.promotion_id || null,
    //     });
    //   });

    //   // Oluşturulan option objesi options listesine ekleniyor.
    //   options.push(optionObj);
    // });

    // console.log(options, "options here 6161");

    setFormValues((prev) => ({
      ...prev,
      quote_id: quoteDetails?.quote?.quote_id,
      // options: options,
    }));
  }, [quoteDetails]);

  const handleWarningMessage = (type) => {
    setWarningMessage(type);
    setTimeout(() => {
      setWarningMessage(null);
    }, 5000);
  };

  const handleUpdateQuote = async (student) => {
    setLoader(true);
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");
    let url = `${process.env.REACT_APP_BASE_URL}quotes`;

    // Önce formValues'dan 'price' değerlerini kaldır
    // const modifiedFormValues = {
    //   ...formValues,
    //   options: formValues.options.map((option) => ({
    //     ...option,
    //     accommodations: option.accommodations.map((accommodation) => ({
    //       ...accommodation,
    //       courses: accommodation.courses.map((course) => {
    //         const { price, campus_address, ...restOfCourse } = course; // 'price' değerini çıkart
    //         return restOfCourse;
    //       }),
    //     })),
    //   })),
    // };


    let modifiedFormValues;
    if (student) {
      console.log("new value 1");

      modifiedFormValues = {
        ...formValues,
        student: student,
        student_id: student?.student_id,
      };
    } else {
      console.log("new value 2");

      modifiedFormValues = {
        ...formValues,
        // student_id: formValues?.student?.student_id,
        student_id: null
      };
    }

    try {
      const response = await axiosInstance.put(url, modifiedFormValues, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
          XRefreshToken: `${token}`, // Bearer token burada ekleniyor
          "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
        },
      });
      setLoader(false);
      Swal.fire({
        icon: "success",
        title: `${t("quoteUpdated")}!`,
        showConfirmButton: false,
        showCloseButton: true,
      });
      navigate(`/quotes/${modifiedFormValues.quote_id}/details`);
      getQuoteDetails();
    } catch (error) {
      setLoader(false);
      console.error("Quote Eklenirken Hata oluştu!", error);
      Swal.fire({
        icon: "error",
        title: error?.response?.data?.detail,
        showConfirmButton: false,
        showCloseButton: true,
      });
      return [];
    }
  };

  useEffect(() => {
    if (quoteDetails?.quote?.student?.student_id && students?.length > 0) {
      if (!newStudentControl) {
        const matchedStudent = students.find((student) => {
          return student.student_id === quoteDetails.quote.student.student_id;
        });
        setSelectedStudent(matchedStudent);
      }
    }
  }, [quoteDetails, students, newStudentControl]);

  const handleSendWhatsapp = async () => {
    if (!selectedStudent) {
      handleWarningMessage("selected-student");
      return false;
    } else {
      setLoader(true);
      let accessToken = localStorage.getItem("accessToken");
      let token = localStorage.getItem("loginUser");
      let url = `${process.env.REACT_APP_BASE_URL}whatsapp_quote`;

      const modifiedFormValues = {
        quote_id: quoteDetails?.quote?.quote_id,
      };

      try {
        const response = await axiosInstance.post(url, modifiedFormValues, {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
            XRefreshToken: `${token}`, // Bearer token burada ekleniyor
            "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
          },
        });
        setLoader(false);
        if (window.innerWidth < 768) {
          window.location.href = response?.data?.messag;
        } else {
          window.open(response?.data?.message, "_blank");
        }

        // Swal.fire({
        //   icon: "success",
        //   title: "Quote Updated Successfully!",
        //   showConfirmButton: false,
        //   showCloseButton: true,
        // });
        // navigate(`/quotes/${response?.data?.quote_id}/details`);
      } catch (error) {
        setLoader(false);
        console.error("Quote Eklenirken Hata oluştu!", error);
        Swal.fire({
          icon: "error",
          title: error?.response?.data?.detail,
          showConfirmButton: false,
          showCloseButton: true,
        });
        return [];
      }
    }
  };

  const handleMenuOpen = (event, option) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedOption(option);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedOption(null);
  };

  const handleDuplicateOption = async () => {
    handleMenuClose();
    if (!selectedOption) return;

    try {
      setLoader(true);
      const url = `${process.env.REACT_APP_BASE_URL}duplicate_option`;
      const accessToken = localStorage.getItem("accessToken");
      const token = localStorage.getItem("loginUser");

      const formData = {
        quote_id: quoteDetails?.quote?.quote_id,
        option_id: selectedOption?.option_id
      }


      const response = await axiosInstance.post(url, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          XRefreshToken: `${token}`,
          "Content-Type": "application/json",
        },
      });

      const newOptionId = response.data?.new_option_id;

      if (newOptionId) {
        const newOptionNumber = quoteDetails?.options?.length + 1;

        const duplicatedOption = {
          ...selectedOption,
          option_id: newOptionId,
          name: `Option ${newOptionNumber}`,
        };

        /*  setQuoteDetails((prev) => ({
           ...prev,
           options: [...prev.options, duplicatedOption],
         })); */
        Swal.fire({
          icon: 'success',
          title: `${t("optionDuplicated")}!`,
          text: `${t("optionDuplicatedText")}!`,
          confirmButtonText: t("close"),
          showCloseButton: true
        });
        getQuoteDetails()

      }
    } catch (error) {
      console.error("Option duplicate error:", error);
    } finally {
      setLoader(false);
    }
  }

  const handleDeleteOption = async () => {
    handleMenuClose();
    if (!selectedOption) return;

    try {
      setLoader(true);
      const url = `${process.env.REACT_APP_BASE_URL}quote_option/${selectedOption?.option_id}`;
      const accessToken = localStorage.getItem("accessToken");
      const token = localStorage.getItem("loginUser");

      const response = await axiosInstance.delete(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          XRefreshToken: `${token}`,
          "Content-Type": "application/json",
        },
      });

      /*     setQuoteDetails((prev) => ({
            ...prev,
            options: prev.options.filter(
              (option) => option.option_id !== selectedOption.option_id
            ),
          })); */
      Swal.fire({
        icon: 'success',
        title: `${t("optionDeleted")}!`,
        text: `${t("optionDeletedText")}!`,
        confirmButtonText: t("close"),
        showCloseButton: true
      });
      getQuoteDetails()
    } catch (error) {
      console.error("Option delete error:", error);
    } finally {
      setLoader(false);
    }
  }

  const handleGetOptionDetails = async () => {
    handleMenuClose();
    if (!selectedOption) return;

    try {
      setLoader(true);
      const url = `${process.env.REACT_APP_BASE_URL}quote_option/${selectedOption?.option_id}`;
      const accessToken = localStorage.getItem("accessToken");
      const token = localStorage.getItem("loginUser");

      const response = await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          XRefreshToken: `${token}`,
          "Content-Type": "application/json",
        },
      });

      const optionData = response.data;
      navigate(`/quotes/${quoteDetails?.quote?.quote_id}/details/${selectedOption?.option_id}/edit`, {
        state: { option: optionData },
      });
    } catch (error) {
      console.error("Option edit fetch error:", error);
    } finally {
      setLoader(false);
    }
  };


  return (
    <>
      {loader ? (
        <CircularProgress
          sx={{
            position: "absolute",
            top: "calc(50% - 20px)",
            left: "calc(50% - 20px)",
          }}
        />
      ) : null}
      <Box sx={{ marginTop: { xs: "2rem" } }}>
        <Box>
          <Box
            sx={{
              marginBottom: "2rem",
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: { xs: "100%", sm: "fit-content" },
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Button
                href={selectedStudent && quoteDetails?.quote?.preview}
                target="_blank"
                variant="contained"
                sx={{ textTransform: 'capitalize' }}
                onClick={() => {
                  if (!selectedStudent) {
                    handleWarningMessage("selected-student");
                  }
                }}
              >
                {" "}
                <PreviewIcon sx={{ color: "#ffffff" }} /> {t("preview")}
              </Button>
              {quoteDetails?.quote?.accepted_at ? null : (
                <Button
                  onClick={() => {
                    if (!selectedStudent) {
                      handleWarningMessage("selected-student");
                    } else {
                      dispatch(
                        openModal(
                          <SendEmailModal quoteDetails={quoteDetails} />
                        )
                      );
                    }
                  }}
                  sx={{ margin: { xs: "1rem 0", sm: "0 1rem" }, textTransform: 'capitalize' }}
                  variant="contained"
                >
                  {" "}
                  <EmailIcon sx={{ color: "#ffffff" }} /> {t("sendToStudent")}
                </Button>
              )}

              {quoteDetails?.quote?.accepted_at ? null : (
                <Button sx={{ textTransform: 'capitalize' }} variant="contained" onClick={handleSendWhatsapp}>
                  {" "}
                  <PhoneAndroidIcon sx={{ color: "#ffffff" }} /> {t("sendWithWhatsapp")}
                </Button>
              )}

              {quoteDetails?.quote?.accepted_at ? null : (
                <Button
                  sx={{ margin: { xs: "1rem 0", sm: "0 1rem" }, textTransform: 'capitalize' }}
                  variant="contained"
                  onClick={() =>
                    dispatch(
                      openModal(
                        <CreateNewStudentModal
                          setSelectedStudent={setSelectedStudent}
                          setStudents={setStudents}
                          setNewStudentControl={setNewStudentControl}
                          handleUpdateQuote={handleUpdateQuote}
                          getStudents={getStudents}
                        />
                      )
                    )
                  }
                >
                  {" "}
                  <PersonPinIcon sx={{ color: "#ffffff" }} />
                  {t("createNewStudent")}
                </Button>
              )}
            </Box>
            <Typography
              sx={{ fontWeight: "700", marginTop: { xs: "1rem", sm: "0" } }}
            >
              {t("quoteId")}: #{quoteDetails?.quote?.quote_id}
            </Typography>
          </Box>
          {/* <Box
            sx={{ boxShadow: "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)", padding: "1.5rem 1rem" }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  onChange={handleChange}
                  // disabled={loader}
                  disabled
                  fullWidth
                  value={quoteDetails?.quote?.student_name}
                  id="outlined-basic"
                  label="Student Name"
                  name="student_name"
                  variant="outlined"
                  type="text"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disabled
                    sx={{
                      width: "100%",
                    }}
                    label="Issue Date"
                    value={dayjs(quoteDetails?.quote?.issue_date)}
                    onChange={handleChange}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disabled
                    sx={{
                      width: "100%",
                    }}
                    label="Accepted At"
                    value={dayjs(quoteDetails?.quote?.accepted_at)}
                    onChange={handleChange}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  onChange={handleChange}
                  // disabled={loader}
                  disabled
                  fullWidth
                  value={quoteDetails?.quote?.quote_status
                    ?.split("_")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                  id="outlined-basic"
                  label="Quote Status"
                  name="quote_status"
                  variant="outlined"
                  type="text"
                />
              </Grid>
            </Grid>
          </Box> */}

          <Card
            sx={{
              // boxShadow:
              //   "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)",
              padding: "1.5rem 1rem",
              borderRadius: "1rem",
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Autocomplete
                    sx={{
                      fieldset: {
                        borderColor:
                          warningMessage &&
                          warningMessage === "selected-student" &&
                          "red",
                      },
                    }}
                    fullWidth
                    value={
                      selectedStudent
                        ? selectedStudent
                        : formValues?.student
                          ? formValues?.student
                          : null
                    }
                    onChange={handleChangeStudent}
                    disablePortal
                    id="combo-box-demo"
                    options={students || []}
                    disabled={quoteDetails?.quote?.accepted_at}
                    getOptionLabel={(option) => option.student_name} // 'name' özelliğini label olarak kullan
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("student")}
                        placeholder={t("selectStudent")}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <PersonIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                  {warningMessage && warningMessage === "selected-student" ? (
                    <Box
                    // sx={{ position: "absolute", bottom: 0, left: 0 }}
                    >
                      <Typography margin={0} variant="caption" color={"error"}>
                        {t("pleaseSelectStudent")}
                      </Typography>
                    </Box>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={i18n.language === "cn" ? "zh-cn" : i18n.language}>
                  <DatePicker
                    sx={{ width: "100%", textTransform: 'capitalize' }}
                    disabled={quoteDetails?.quote?.accepted_at}
                    label={t("expiryDate")}
                    name="expiry_date"
                    value={
                      (quoteDetails &&
                        quoteDetails?.quote &&
                        quoteDetails?.quote?.expiry_date &&
                        dayjs(quoteDetails?.quote?.expiry_date)) ||
                      dayjs(formValues?.expiry_date)
                    }
                    onChange={(newValue) =>
                      handleChange(newValue, "expiry_date")
                    }
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12}>
                <Button
                  sx={{
                    marginTop: "1rem",
                    textTransform: 'capitalize'
                  }}
                  disabled={
                    !formValues?.expiry_date || !formValues?.student?.student_id
                  }
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    formValues?.expiry_date &&
                    formValues?.student?.student_id &&
                    handleUpdateQuote()
                  }
                >
                  {t("save")}
                </Button>
              </Grid>
            </Grid>
            {/* <Button
              sx={{
                marginTop: "1rem",
              }}
              disabled={!formValues?.expiry_date || !formValues?.student_id}
              variant="contained"
              color="primary"
              onClick={() =>
                formValues?.expiry_date &&
                formValues?.student_id 
                && handleUpdateQuote()
              }
            >
              Save
            </Button> */}
          </Card>
          <>
            {/* {options?.map((option, idx) => {
              return (
                <Box
                  sx={{
                    marginTop: "2rem",
                    boxShadow: "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)",
                    padding: "1.5rem 1rem",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      borderBottom: "1px dashed #e9ecee",
                      paddingBottom: "1rem",
                    }}
                  >
                    <FormatListBulletedIcon sx={{ marginRight: ".5rem" }} />
                    <Typography sx={{ fontWeight: "700" }}>
                      {option.option_name}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      marginTop: "2rem",
                    }}
                  >
                    <Box
                      sx={{
                        position: "relative",
                        overflow: "hidden",
                        width: { xs: "100%", md: "300px", lg: "400px" },
                        marginRight: { xs: "0", md: "2rem" },
                        marginBottom: { xs: "1.5rem", md: "0" },
                      }}
                    >
                      <Box
                        sx={{
                          backgroundImage: `url(${option.provider_img})`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "left",
                          width: { xs: "100%", md: "400px" },
                          height: { xs: "300px", md: "100%" },
                          filter: "blur(8px)",
                        }}
                      ></Box>
                      <img
                        src={option.provider_img}
                        style={{
                          position: "absolute",
                          inset: "0",
                          width: "90%",
                          left: "5%",
                          borderRadius: "1rem",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        width: {
                          xs: "100%",
                          md: "calc(100% - 332px)",
                          lg: "calc(100% - 432px)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          borderBottom: "1px dashed #e9ecee",
                          paddingBottom: "1rem",
                        }}
                      >
                        <Typography color="primary" variant="h6">
                          {option.provider_name}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <LocationOnIcon
                            sx={{ fontSize: "14px", color: "#23416a" }}
                          />
                          <Typography variant="body2">
                            {option.provider_address}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex" }}>
                          <Typography
                            color="primary"
                            variant="body2"
                            sx={{ marginRight: ".5rem" }}
                          >
                            {t("academicYear")}:
                          </Typography>
                          <Typography variant="body2">
                            {option.academic_year}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          marginTop: "1rem",
                          borderBottom: "1px dashed #e9ecee",
                          paddingBottom: "1rem",
                        }}
                      >
                        <Typography color="primary" variant="h6">
                          {t("accommodations")}
                        </Typography>
                        <Typography variant="body2">
                          {option.campus_name}
                        </Typography>
                        <Typography variant="body2">
                          {option.duration}
                        </Typography>
                        <Typography variant="body2">
                          {option.weekly_price}
                        </Typography>
                        <Typography sx={{ fontWeight: "700" }}>
                          {option.uncut_price}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            justifyContent: "space-between",
                            background: "#23416a26",
                            padding: "1rem",
                            marginTop: "1rem",
                            borderRadius: ".25rem",
                          }}
                        >
                          <Typography
                            sx={{
                              maxWidth: { xs: "100%", sm: "50%" },
                              marginRight: { xs: "1rem", sm: "0" },
                              marginBottom: { xs: "1rem", sm: "0" },
                            }}
                          >
                            {option.discount_details?.discount_description}
                          </Typography>
                          <Typography>
                            {option.discount_details?.discount_amount}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography>Subtotal</Typography>
                          <Typography>{option.subtotal}</Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          marginTop: "1rem",
                          borderBottom: "1px dashed #e9ecee",
                          paddingBottom: "1rem",
                        }}
                      >
                        <Typography color="primary" variant="h6">
                          Fee/s
                        </Typography>
                        {option.fees?.map((fee, idx) => {
                          return (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography variant="body2">
                                {fee.fee_name}
                              </Typography>
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{ marginRight: ".5rem" }}
                                >
                                  {fee.fee_amount_first}
                                </Typography>
                                <Typography variant="body2">
                                  {fee.fee_amount_second}
                                </Typography>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "1rem",
                        }}
                      >
                        <Typography variant="h5" color="primary">
                          Total:
                        </Typography>
                        <Typography variant="h6" color="primary">
                          {option.total_price}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              );
            })} */}
            {quoteDetails?.options?.map((option) => {
              return (
                <Card
                  sx={{
                    borderRadius: "1rem",
                    marginTop: "2rem",
                    // boxShadow:
                    //   "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)",
                    padding: "1.5rem 1rem",
                    background:
                      quoteDetails?.quote?.selected_option_id ===
                        option?.option_id
                        ? lightMode
                          ? "#44b8001c"
                          : "#112d00"
                        : lightMode
                          ? "#ffffff"
                          : "#292929",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      // borderBottom: "1px dashed #e9ecee",
                      borderBottom: `1px dashed ${quoteDetails?.quote?.selected_option_id ===
                        option?.option_id
                        ? lightMode
                          ? "#bfbfbf"
                          : "#e9ecee"
                        : "#e9ecee"
                        }`,
                      paddingBottom: "1rem",
                    }}
                  >
                    <FormatListBulletedIcon sx={{ marginRight: ".5rem" }} />
                    <Typography sx={{ fontWeight: "700" }}>
                      {option?.name}
                    </Typography>


                    {
                      quoteDetails?.quote?.accepted_at === null ?
                        quoteDetails?.quote?.selected_option_id !==
                          option?.option_id ? (
                          <IconButton sx={{
                            marginLeft: 'auto'
                          }} onClick={(e) => handleMenuOpen(e, option)}>
                            <MoreVertIcon />
                          </IconButton>
                        ) : null
                        : null
                    }

                    {/*       (quoteDetails?.quote?.selected_option_id !==
                        option?.option_id)) ? (

                      ) : null */}

                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      marginTop: "2rem",
                    }}
                  >
                    <Box
                      sx={{
                        position: "relative",
                        overflow: "hidden",
                        width: { xs: "100%", md: "300px", lg: "400px" },
                        marginRight: { xs: "0", md: "2rem" },
                        marginBottom: { xs: "1.5rem", md: "0" },

                        borderRadius: "1rem",
                        height: "400px",
                        // border: "1px solid #afafaf",
                        boxShadow: "0px 0px 3px #cfcfcf",
                      }}
                    >
                      <Box
                        sx={{
                          backgroundImage: option?.courses[0]?.course?.images
                            ?.length
                            ? `url(${option?.courses[0]?.course?.images[0].replace(
                              "devcrm1",
                              "crm"
                            )})`
                            : "unset",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "left",
                          backgroundSize: "cover",
                          width: { xs: "100%", md: "400px" },
                          height: { xs: "300px", md: "100%" },
                          maxHeight: "400px",
                          filter: "blur(3px)",
                        }}
                      ></Box>
                      <img
                        src={
                          option?.courses[0]?.course?.images?.length
                            ? option?.courses[0]?.course?.images[0].replace(
                              "devcrm1",
                              "crm"
                            )
                            : "javascript:;"
                        }
                        style={{
                          position: "absolute",
                          inset: "0",
                          width: "90%",
                          left: "5%",
                          borderRadius: "1rem",
                          height: "100%",
                          maxHeight: "400px",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: {
                          xs: "100%",
                          md: "calc(100% - 332px)",
                          lg: "calc(100% - 432px)",
                        },
                      }}
                    >
                      {/* COURSES START */}
                      {option?.courses?.map((course, idx) => {
                        return option?.courses?.length > 1 && idx >= 1 ? (
                          coursesControl ? (
                            <>
                              {course?.discount_request_status === null ? (
                                <Button
                                  disabled={
                                    quoteDetails?.quote?.accepted_at
                                      ? true
                                      : false
                                  }
                                  variant="contained"
                                  color="primary"
                                  sx={{
                                    mb: 2,
                                    ml: "auto",
                                    textTransform: 'capitalize'
                                  }}
                                  onClick={() =>
                                    handleOpenModal({ option, course })
                                  }
                                >
                                  {t("discountRequest")}
                                </Button>
                              ) : course?.discount_request_status ===
                                "approved" ? (
                                <Button
                                  disabled
                                  variant="contained"
                                  color="primary"
                                  sx={{
                                    mb: 2,
                                    ml: "auto",
                                  }}
                                  onClick={() =>
                                    handleOpenModal({ option, course })
                                  }
                                >
                                  Discount Approved
                                </Button>
                              ) : course?.discount_request_status ===
                                "declined" ? (
                                <>
                                  <Button
                                    disabled={
                                      quoteDetails?.quote?.accepted_at
                                        ? true
                                        : false
                                    }
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                      mb: 2,
                                      ml: "auto",
                                      textTransform: 'capitalize'
                                    }}
                                    onClick={() =>
                                      handleOpenModal({ option, course })
                                    }
                                  >
                                    {t("discountRequest")}
                                  </Button>
                                  {course?.discount_request_status ===
                                    "declined" &&
                                    !quoteDetails?.quote?.accepted_at && (
                                      <Typography
                                        mb={3}
                                        textAlign={"end"}
                                        variant="contained"
                                        fontStyle={"italic"}
                                      >
                                        <InfoOutlineIcon
                                          fontSize="small"
                                          sx={{
                                            position: "relative",
                                            top: 3,
                                            left: -3,
                                            transform: "skew(-10deg, 0deg)",
                                            color: theme.palette.primary.main,
                                          }}
                                        />
                                        {t("quoteDetailsUnfortunately")}
                                      </Typography>
                                    )}
                                </>
                              ) : course?.discount_request_status ===
                                "waiting_for_approval" ? (
                                <Button
                                  disabled
                                  variant="contained"
                                  color="primary"
                                  sx={{
                                    mb: 2,
                                    ml: "auto",
                                    textTransform: 'capitalize'
                                  }}
                                  onClick={() =>
                                    handleOpenModal({ option, course })
                                  }
                                >
                                  {t("discountRequested")}
                                </Button>
                              ) : (
                                <Button
                                  disabled={
                                    quoteDetails?.quote?.accepted_at
                                      ? true
                                      : false
                                  }
                                  variant="contained"
                                  color="primary"
                                  sx={{
                                    mb: 2,
                                    ml: "auto",
                                    textTransform: 'capitalize'
                                  }}
                                  onClick={() =>
                                    handleOpenModal({ option, course })
                                  }
                                >
                                  {t("discountRequest")}
                                </Button>
                              )}

                              <Box
                                sx={{
                                  // backgroundColor: `rgba(${
                                  //   lightMode ? "255 255 255" : "28 37 46"
                                  // } / 0.9)`,
                                  // backgroundImage: `url(${paperBackFirstImg}), url(${paperBackSecondImg})`,
                                  // backgroundSize: "50%, 50%",
                                  // backgroundRepeat: "no-repeat",
                                  // backgroundPosition: "right top, left bottom",
                                  // backdropFilter: "blur(20px)",
                                  // transition:
                                  //   "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
                                  // outline: 0,

                                  // background: "red",
                                  padding: "1rem 0",
                                  boxShadow: "0px 0px 3px #cfcfcf",
                                  padding: "1rem",
                                  marginBottom: "1.5rem",
                                  borderRadius: "1rem",
                                }}
                              >
                                <Box
                                  sx={{
                                    borderBottom: "1px dashed #e9ecee",
                                    paddingBottom: "1rem",
                                  }}
                                >
                                  <Typography color="primary" variant="h6">
                                    <strong>
                                      {course?.option_course_partner}
                                    </strong>{" "}
                                    - {course?.option_course_campus}
                                  </Typography>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <LocationOnIcon
                                      sx={{
                                        fontSize: "14px",
                                        color: "#23416a",
                                      }}
                                    />
                                    <Typography variant="body2">
                                      {course?.course?.campus?.campus_address}
                                    </Typography>
                                  </Box>

                                  <Box sx={{ display: "flex" }}>
                                    <Typography
                                      color="primary"
                                      variant="body2"
                                      sx={{ marginRight: ".5rem", textTransform: 'capitalize' }}
                                    >
                                      {t("academicYear")}:
                                    </Typography>
                                    <Typography variant="body2">
                                      {course?.academic_year}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Box
                                  sx={{
                                    marginTop: "1rem",
                                    // borderBottom: "1px dashed #e9ecee",
                                    // paddingBottom: "1rem",
                                  }}
                                >
                                  <Typography color="primary" variant="h6">
                                    {t("accommodations")}
                                  </Typography>
                                  <Typography variant="body2">
                                    {course?.option_course_name}
                                  </Typography>
                                  <Typography variant="body2">
                                    {option?.duration}
                                  </Typography>

                                  <Typography textTransform={"capitalize"} variant="body2">
                                    {course?.option_course_start_date} -{" "}
                                    {course?.option_course_end_date} (
                                    {/*
                                  {course?.option_course_duration}{" "}
                                  {course?.option_course_duration > 1
                                    ? course?.option_course_duration_unit + "s"
                                    : course?.option_course_duration_unit}{" "} */}
                                    {course?.option_course_duration < 7
                                      ? course?.option_course_duration > 1
                                        ? course?.option_course_duration + ` days`
                                        : course?.option_course_duration + ` day`
                                      : course?.option_course_duration % 7 === 0
                                        ? course?.option_course_duration / 7 === 1
                                          ? course?.option_course_duration / 7 +
                                          t("week")
                                          : course?.option_course_duration / 7 +
                                          // t("weeks")
                                          t("week")
                                        : Math.floor(
                                          course?.option_course_duration / 7
                                        ) +
                                        ` ${t("week")}
                                    
                                      ${t("and")} ` +
                                        (course?.option_course_duration % 7) +
                                        ` ${t("day")}`}
                                    )
                                  </Typography>
                                  <Typography variant="body2">
                                    {paraFormat(
                                      course?.option_course_weekly_price
                                    )}{" "}
                                    / Week
                                  </Typography>
                                  {/*  <Typography sx={{ fontWeight: "700" }}>
                                    {paraFormat(
                                      course?.option_course_total_price
                                    )}
                                  </Typography> */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginTop: "1rem",
                                      borderBottom: "1px dashed #e9ecee",
                                      paddingBottom: "1rem",
                                    }}
                                  >
                                    {/* <Typography variant="body1">
                                      Subtotal
                                    </Typography> */}
                                    <Typography variant="h6">
                                      {paraFormat(
                                        course?.option_course_gross_subtotal_price
                                      )}
                                    </Typography>
                                  </Box>
                                  {course?.promotion?.map((promotion) => {
                                    return (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: {
                                            xs: "column",
                                            sm: "row",
                                          },
                                          justifyContent: "space-between",
                                          background: "#44b8001c",
                                          padding: "1rem",
                                          marginTop: "1rem",
                                          borderRadius: ".25rem",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            maxWidth: {
                                              xs: "100%",
                                              sm: "50%",
                                            },
                                            marginRight: {
                                              xs: "1rem",
                                              sm: "0",
                                            },
                                            marginBottom: {
                                              xs: "1rem",
                                              sm: "0",
                                            },
                                          }}
                                        >
                                          {promotion?.promotion_type === "fixed"
                                            ? `${promotion?.promotion_name} (${promotion?.promotion_amount} GBP Discount)`
                                            : `${promotion?.promotion_name} (%
                                              ${promotion?.promotion_percentage} Discount)`}
                                        </Typography>
                                        <Typography>
                                          -{" "}
                                          {paraFormat(
                                            promotion?.promotion_amount
                                          )}
                                        </Typography>
                                      </Box>
                                    );
                                  })}
                                </Box>
                              </Box>
                            </>
                          ) : null
                        ) : (
                          <>
                            {course?.discount_request_status === null ? (
                              <Button
                                disabled={
                                  quoteDetails?.quote?.accepted_at
                                    ? true
                                    : false
                                }
                                variant="contained"
                                color="primary"
                                sx={{
                                  mb: 2,
                                  ml: "auto",
                                  textTransform: 'capitalize'
                                }}
                                onClick={() =>
                                  handleOpenModal({ option, course })
                                }
                              >
                                {t("discountRequest")}
                              </Button>
                            ) : course?.discount_request_status ===
                              "approved" ? (
                              <Button
                                disabled
                                variant="contained"
                                color="primary"
                                sx={{
                                  mb: 2,
                                  ml: "auto",
                                }}
                                onClick={() =>
                                  handleOpenModal({ option, course })
                                }
                              >
                                Discount Approved
                              </Button>
                            ) : course?.discount_request_status ===
                              "declined" ? (
                              <>
                                <Button
                                  disabled={
                                    quoteDetails?.quote?.accepted_at
                                      ? true
                                      : false
                                  }
                                  variant="contained"
                                  color="primary"
                                  sx={{
                                    mb: 2,
                                    ml: "auto",
                                    textTransform: 'capitalize'
                                  }}
                                  onClick={() =>
                                    handleOpenModal({ option, course })
                                  }
                                >
                                  {t("discountRequest")}
                                </Button>
                                {course?.discount_request_status ===
                                  "declined" &&
                                  !quoteDetails?.quote?.accepted_at && (
                                    <Typography
                                      mb={3}
                                      textAlign={"end"}
                                      variant="contained"
                                      fontStyle={"italic"}
                                    >
                                      <InfoOutlineIcon
                                        fontSize="small"
                                        sx={{
                                          position: "relative",
                                          top: 3,
                                          left: -3,
                                          transform: "skew(-10deg, 0deg)",
                                          color: theme.palette.primary.main,
                                        }}
                                      />
                                      {t("quoteDetailsUnfortunately")}
                                    </Typography>
                                  )}
                              </>
                            ) : course?.discount_request_status ===
                              "waiting_for_approval" ? (
                              <Button
                                disabled
                                variant="contained"
                                color="primary"
                                sx={{
                                  mb: 2,
                                  ml: "auto",
                                  textTransform: 'capitalize'
                                }}
                                onClick={() =>
                                  handleOpenModal({ option, course })
                                }
                              >
                                {t("discountRequested")}
                              </Button>
                            ) : (
                              <Button
                                disabled={
                                  quoteDetails?.quote?.accepted_at
                                    ? true
                                    : false
                                }
                                variant="contained"
                                color="primary"
                                sx={{
                                  mb: 2,
                                  ml: "auto",
                                  textTransform: 'capitalize'
                                }}
                                onClick={() =>
                                  handleOpenModal({ option, course })
                                }
                              >
                                {t("discountRequest")}
                              </Button>
                            )}

                            <Box
                              sx={{
                                // backgroundColor: `rgba(${
                                //   lightMode ? "255 255 255" : "28 37 46"
                                // } / 0.9)`,
                                // backgroundImage: `url(${paperBackFirstImg}), url(${paperBackSecondImg})`,
                                // backgroundSize: "50%, 50%",
                                // backgroundRepeat: "no-repeat",
                                // backgroundPosition: "right top, left bottom",
                                // backdropFilter: "blur(20px)",
                                // transition:
                                //   "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
                                // outline: 0,

                                // background: "blue",
                                boxShadow: "0px 0px 3px #cfcfcf",
                                padding: "1rem",
                                marginBottom: "1.5rem",
                                borderRadius: "1rem",
                              }}
                            >
                              <Box
                                sx={{
                                  borderBottom: "1px dashed #e9ecee",
                                  paddingBottom: "1rem",
                                }}
                              >
                                <Typography color="primary" variant="h6">
                                  <strong>
                                    {course?.option_course_partner}
                                  </strong>{" "}
                                  - {course?.option_course_campus}
                                </Typography>
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <LocationOnIcon
                                    sx={{ fontSize: "14px", color: "#23416a" }}
                                  />
                                  <Typography variant="body2">
                                    {course?.course?.campus?.campus_address}
                                  </Typography>
                                </Box>
                                <Box sx={{ display: "flex" }}>
                                  <Typography
                                    color="primary"
                                    variant="body2"
                                    sx={{ marginRight: ".5rem", textTransform: 'capitalize' }}
                                  >
                                    {t("academicYear")}:
                                  </Typography>
                                  <Typography variant="body2">
                                    {course?.academic_year}
                                  </Typography>
                                </Box>
                                {/* <Typography variant="body2">
                                  {course?.option_course_start_date} -{" "}
                                  {course?.option_course_end_date} (
                                  {course?.option_course_duration}{" "}
                                  {course?.option_course_duration > 1
                                    ? course?.option_course_duration_unit + "s"
                                    : course?.option_course_duration_unit}{" "}
                                  )
                                </Typography> */}
                              </Box>
                              <Box
                                sx={{
                                  marginTop: "1rem",
                                  // paddingBottom: "1rem",
                                }}
                              >
                                <Typography color="primary" variant="h6">
                                  {t("accommodations")}
                                </Typography>
                                <Typography variant="body2">
                                  {course?.option_course_name}
                                </Typography>
                                <Typography variant="body2">
                                  {option?.duration}
                                </Typography>
                                <Typography textTransform={"capitalize"} variant="body2">
                                  {course?.option_course_start_date} -{" "}
                                  {course?.option_course_end_date} (
                                  {/* 
                                  {course?.option_course_duration}{" "}
                                  {course?.option_course_duration > 1
                                    ? course?.option_course_duration_unit + "s"
                                    : course?.option_course_duration_unit}{" "} */}
                                  {course?.option_course_duration < 7
                                    ? course?.option_course_duration > 1
                                      ? course?.option_course_duration + ` days`
                                      : course?.option_course_duration + ` day`
                                    : course?.option_course_duration % 7 === 0
                                      ? course?.option_course_duration / 7 === 1
                                        ? course?.option_course_duration / 7 +
                                        t("week")
                                        : course?.option_course_duration / 7 +
                                        // t("weeks")
                                        t("week")
                                      : Math.floor(
                                        course?.option_course_duration / 7
                                      ) +
                                      ` ${t("week")}
                                    
                                      ${t("and")} ` +
                                      (course?.option_course_duration % 7) +
                                      ` ${t("day")}`}
                                  )
                                </Typography>
                                <Typography textTransform={"capitalize"} variant="body2">
                                  {paraFormat(
                                    course?.option_course_weekly_price
                                  )}{" "}
                                  / {t("week")}
                                </Typography>
                                {/*      <Typography sx={{ fontWeight: "700" }}>
                                  {paraFormat(
                                    course?.option_course_total_price
                                  )}
                                </Typography> */}

                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: "1rem",
                                    // borderBottom: "1px dashed #e9ecee",
                                    // paddingBottom: "1rem",
                                  }}
                                >
                                  {/* <Typography variant="body1">
                                    Subtotal
                                  </Typography> */}
                                  <Typography variant="h6">
                                    {paraFormat(
                                      option?.courses[0]
                                        ?.option_course_gross_subtotal_price
                                    )}
                                  </Typography>
                                </Box>
                                {course?.promotion?.map((promotion) => {
                                  return (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: {
                                          xs: "column",
                                          sm: "row",
                                        },
                                        justifyContent: "space-between",
                                        background: "#44b8001c",
                                        padding: "1rem",
                                        marginTop: "1rem",
                                        borderRadius: ".25rem",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          maxWidth: { xs: "100%", sm: "50%" },
                                          marginRight: { xs: "1rem", sm: "0" },
                                          marginBottom: { xs: "1rem", sm: "0" },
                                        }}
                                      >
                                        {/* {promotion?.promotion_name} (%
                                        {promotion?.promotion_percentage}{" "}
                                        Discount) */}
                                        {promotion?.promotion_type === "fixed"
                                          ? `${promotion?.promotion_name} (${promotion?.promotion_amount} GBP Discount)`
                                          : `${promotion?.promotion_name} (%
                                              ${promotion?.promotion_percentage} Discount)`}
                                      </Typography>
                                      <Typography>
                                        -{" "}
                                        {paraFormat(
                                          promotion?.promotion_amount
                                        )}
                                      </Typography>
                                    </Box>
                                  );
                                })}
                              </Box>
                            </Box>
                          </>
                        );
                      })}
                      {option?.courses?.length > 1 ? (
                        coursesControl ? (
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ maxWidth: "fit-content", textTransform: 'capitalize' }}
                            onClick={() => handleChangeCourseControl()}
                          >
                            {t("hide")}
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ maxWidth: "fit-content", textTransform: 'capitalize' }}
                            onClick={() => handleChangeCourseControl()}
                          >
                            {t("seeAllCourses")}
                          </Button>
                        )
                      ) : null}

                      {/* COURSES END */}

                      <Box
                        sx={{
                          marginTop: "1rem",
                          borderBottom: `1px dashed ${quoteDetails?.quote?.selected_option_id ===
                            option?.option_id
                            ? lightMode
                              ? "#bfbfbf"
                              : "#e9ecee"
                            : "#e9ecee"
                            }`,
                          paddingBottom: "1rem",
                        }}
                      >
                        <Typography textTransform={"capitalize"} color="primary" variant="h6">
                          {t("fees")}
                        </Typography>
                        {option?.services?.map((service, idx) => {
                          return (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography variant="body2">
                                {service?.option_service_name}
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{ marginRight: ".5rem" }}
                                >
                                  +VAT (
                                  {paraFormat(service?.option_service_vat)})
                                </Typography>
                                <Typography variant="body2">
                                  {paraFormat(
                                    service?.option_service_gross_price
                                  )}
                                </Typography>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: "1px dashed #e9ecee",
                          paddingBottom: "1rem",
                          marginTop: "1rem",
                        }}
                      >
                        <Typography textTransform={"capitalize"} variant="h6">{t("subTotal")}:</Typography>
                        <Typography variant="h6">
                          {paraFormat(option?.subtotal)}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "1rem",
                        }}
                      >
                        <Typography textTransform={"capitalize"} variant="h5" color="primary">
                          {t("total")}:
                        </Typography>
                        <Typography variant="h5" color="primary">
                          {paraFormat(option?.total)}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Card>
              );
            })}
          </>
        </Box>
      </Box>

      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem sx={{ textTransform: 'capitalize' }} onClick={handleGetOptionDetails}>{t("edit")}</MenuItem>
        <MenuItem sx={{ textTransform: 'capitalize' }} onClick={handleDuplicateOption}>{t("duplicate")}</MenuItem>
        <MenuItem sx={{ textTransform: 'capitalize' }} onClick={handleDeleteOption}>{t("delete")}</MenuItem>
      </Menu>
    </>
  );
}
